/**
 * Fetch wrapper that automatically adds Authorization header
 */

import { getCurrentToken } from '../services/api';

export async function fetchWithAuth(url: string, options: RequestInit = {}): Promise<Response> {
  const token = getCurrentToken();

  const headers = new Headers(options.headers);
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  return fetch(url, {
    ...options,
    headers,
  });
}
